import React from 'react';
import MroLabLanePage from './MroLabLanePage';

export default function MroLabManagerPage() {
  return <MroLabLanePage laneKey="manager" />;
}
